import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from '../components/layout/AuthLayout.jsx';
import api from '../lib/api.js';

export default function ResetPinPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pin, setPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError('');
    if (pin !== confirmPin) return setError('I PIN non corrispondono');
    setLoading(true);
    try {
      await api.post('/auth/reset-pin', { email, password, new_pin: pin });
      setSuccess(true);
    } catch (err) {
      setError(err?.message || 'Reset fallito');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout
      title="Reset PIN"
      subtitle="Cambia il PIN personale utilizzando email e password"
      footer={<>Hai bisogno di altra assistenza?{' '}<Link to="/forgot" className="text-brand-300 hover:underline">Recupera accesso</Link></>}
    >
      {!success ? (
        <form onSubmit={submit} className="space-y-3">
          <div className="flex flex-col gap-1">
            <label className="text-xs text-surface-4" htmlFor="resetpin-email">Email *</label>
            <input id="resetpin-email" className="input" type="email" autoComplete="email" autoFocus required value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs text-surface-4" htmlFor="resetpin-password">Password *</label>
            <input id="resetpin-password" className="input" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs text-surface-4" htmlFor="resetpin-new">Nuovo PIN (4-6 cifre) *</label>
            <input id="resetpin-new" className="input" type="password" inputMode="numeric" autoComplete="new-password" maxLength={6} required value={pin} onChange={e => setPin(e.target.value)} placeholder="******" />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs text-surface-4" htmlFor="resetpin-confirm">Conferma PIN *</label>
            <input id="resetpin-confirm" className="input" type="password" inputMode="numeric" autoComplete="new-password" maxLength={6} required value={confirmPin} onChange={e => setConfirmPin(e.target.value)} placeholder="******" />
          </div>
          {error && <div className="rounded-md border border-danger/30 bg-danger/10 px-3 py-2 text-xs text-danger">{error}</div>}
          <button type="submit" className="btn btn-primary w-full" disabled={loading}>{loading ? 'Salvataggio...' : 'Cambia PIN'}</button>
          <button type="button" className="btn btn-ghost w-full text-xs" onClick={() => navigate('/login')}>Torna al login</button>
        </form>
      ) : (
        <div className="space-y-3 text-sm">
          <p className="text-success">PIN modificato con successo.</p>
          <button type="button" className="btn btn-primary w-full" onClick={() => navigate('/login')}>Vai al login</button>
        </div>
      )}
    </AuthLayout>
  );
}